<template>
  <div>
    <video-js :media="data" />
    <div v-if="data.caption" class="caption" v-html="data.caption"></div>
  </div>
</template>

<script>

  export default {
    name: 'ContentModuleVideo',
    props: {
      data: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  .caption {
    @include caption;
    margin-top:1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/content-module/video.vue